import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';

const opsAgentPage = PageBlueprint.make({
  name: 'ops-agent',
  params: {
    path: '/ops-agent',
    title: 'Ops Agent',
    loader: () =>
      import('./components/OpsAgentPage').then(m => <m.OpsAgentPage />),
  },
});

/**
 * Ops assistant widget: a Foundry-backed chat page reading the ops MCP
 * gateway (dev k8s/azure/argocd/grafana).
 *
 * @public
 */
export default createFrontendPlugin({
  pluginId: 'ops-agent',
  extensions: [opsAgentPage],
});
